<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    //接口地址url的统一管理
    import URL from '@/views/newmis36/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import download from '@/utils/download'
    const directTypeList = {open:"持仓",close:"平仓"};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
        },
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if (clickName == "detail"){
                    this.$router.push({path:"/newmis36/share/direct", query: { accountNo:row.accountNo,directType:row.directType,label:'TREX'} });
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if(window.$t('txmis.bt.down') == clickName){
                    //隐藏关键字段
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
                    download.exportExcel(URL.share.tradeShare.export,param,"晒单分享记录");
                }else if(window.$t('txmis.bt.export') == clickName){
                    const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
                    download.exportExcel(URL.share.tradeShare.export,param,"晒单分享记录");
                }
            },
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[
                      { title:"账号" , field: 'accountNo'},
                      { title:"手机号" , field: 'mobilePhone'},
                      { title:"分享场景" , field: 'directType',type:2,optionList:directTypeList},
                      { title: window.$t('txmis.common.startTime'), field: 'startTime',type:5},
                      { title: window.$t('txmis.common.endTime'), field: 'endTime',type:5},
                      {click:window.$t('txmis.bt.search')},
                      {click: window.$t('txmis.bt.down'),auth:"tracker.down"},
                      {click: window.$t('txmis.bt.export'),auth:"tracker.export"},
                  ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: URL.share.tradeShare.list, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        { title:"账号" , field: 'accountNo'},
                        { title:"手机号" , field: 'mobilePhone'},
                        { title:"交易产品" , field: 'symbol'},
                        { title:"盈利" , field: 'profit'},
                        { title:"分享场景" , field: 'directType',render:(data,full)=>{
                                return directTypeList[data];
                            }},
                        { title:"分享时间" , field: 'createTime',render:(data,full)=>{
                                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                            }},
                        {field:"查看",title:"转化人数（推荐的开户人数）",size:"mini",click:"detail",type:"primary",icon:"el-icon-edit"},
                    ]
                }
            }
        }
    }
</script>
